import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService as AuthGuard } from '../@dva/services/auth-guard.service';
import { LoginGuardService as LoginGuard } from '../@dva/services/login-guard.service';
import { PermissionGuardService as PermissionGuard } from '../@dva/services/permission-guard.service';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/authentication/login/login.module').then((m) => m.LoginModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/authentication/register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'register/:id',
    loadChildren: () => import('./pages/authentication/register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'forgot',
    loadChildren: () => import('./pages/authentication/forgot/forgot.module').then((m) => m.ForgotModule),
  },
  {
    path: 'forgot/:id',
    loadChildren: () => import('./pages/authentication/forgot/forgot.module').then((m) => m.ForgotModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [PermissionGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
        pathMatch: 'full',
      },
      {
        path: 'layout-manager',
        loadChildren: () => import('./pages/layout-manager/layout-manager.module').then((m) => m.LayoutManagerModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'modeler',
        loadChildren: () => import('./pages/layout-manager/modeler/modeler.module').then((m) => m.ModelerModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'auxiliary-database',
        loadChildren: () =>
          import('./pages/auxiliary-database/auxiliary-database.module').then((m) => m.AuxiliaryDatabaseModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'historical-data',
        loadChildren: () =>
          import('./pages/historical-data/historical-data.module').then((m) => m.HistoricalDataModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'filters',
        loadChildren: () => import('./pages/filters/filters.module').then((m) => m.FiltersModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'filter-create-update',
        loadChildren: () =>
          import('./pages/filters/filter-create-update/filter-create-update.module').then(
            (m) => m.FilterCreateUpdateModule,
          ),
          data: { requiresFullAccess: true }
      },
      {
        path: 'rules',
        loadChildren: () => import('./pages/rules/rules.module').then((m) => m.RulesModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'rule-create-update',
        loadChildren: () =>
          import('./pages/rules/rule-create-update/rule-create-update.module').then((m) => m.RuleCreateUpdateModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'dynamic-fields',
        loadChildren: () => import('./pages/dynamic-fields/dynamic-fields.module').then((m) => m.DynamicFieldsModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'checks-report',
        loadChildren: () => import('./pages/checks-report/checks-report.module').then((m) => m.ChecksReportModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'rules-clones-report',
        loadChildren: () =>
          import('./pages/rule-clones-report/rule-clones-report.module').then((m) => m.RuleClonesReportModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'settings/:section',
        loadChildren: () => import('./pages/settings/settings.module').then((m) => m.SettingsModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'alerts',
        loadChildren: () => import('./pages/alerts/alerts.module').then((m) => m.AlertsModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'alert-create-update',
        loadChildren: () =>
          import('./pages/alerts/alert-create-update/alert-create-update.module').then(
            (m) => m.AlertCreateUpdateModule,
          ),
        data: { requiresFullAccess: true }
      },
      {
        path: 'managements',
        loadChildren: () => import('./pages/management/management.module').then((m) => m.ManagementModule),
        data: { requiresFullAccess: true }
      },
      {
        path: 'management-create-update',
        loadChildren: () =>
          import('./pages/management/management-create-update/management-create-update.module').then(
            (m) => m.ManagementCreateUpdateModule,
          ),
        data: { requiresFullAccess: true }
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
